import { updateWorkOrder } from '#/graphql/mutations';
import type { WorkOrderInput, WorkOrderDetails, UpdateWorkOrderMutation } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { GET_WORK_ORDER } from './useWorkOrderQuery';

const q = gql(updateWorkOrder);

const useWorkOrderUpdate = () => {
  const [mutation, result] = useMutation<UpdateWorkOrderMutation>(q);

  const updateWorkOrder = useCallback(
    async (workOrderId: string, workOrder: WorkOrderDetails & WorkOrderInput) => {
      const {
        __typename,
        id,
        tenantId,
        displayNumber,
        createdAt,
        createdBy,
        updatedAt,
        updatedBy,
        createdByUser,
        updatedByUser,
        tenant,
        number,
        user,
        location,
        assetLocation,
        asset,
        assignedTo,
        closedBy,
        actualCostValue,
        estimatedCostValue,
        estimatedEffort,
        duration,
        isArchived,
        seenByAssignee,
        seenDateTime,
        startOfWorkDateTime,
        endOfWorkDateTime,
        assignmentDateTime,
        assetModel,
        ...workOrderInput
      } = workOrder;

      const response = await mutation({
        variables: {
          id: workOrderId,
          data: workOrderInput,
        },
        refetchQueries: [{ query: GET_WORK_ORDER, variables: { id: workOrderId } }],
        awaitRefetchQueries: true,
      });

      return response.data?.updateWorkOrder || undefined;
    },
    [mutation],
  );

  return { updateWorkOrder, result };
};

export default useWorkOrderUpdate;
